export default "__VITE_ASSET__ca76f543__"